module.exports = __webpack_public_path__ + "static/media/Mentorship.070c25d3.mp4";